'use client';

import { apiPostInvitation } from '@/lib/api/invite';
import { useRequest } from 'ahooks';
import { useRouter, useSearchParams } from 'next/navigation';

// 💣 废弃
export default function InviteCodeBinding() {
  const params = useSearchParams();
  const inviteCode = params.get('tgWebAppStartParam');
  const router = useRouter();

  useRequest(apiPostInvitation, {
    defaultParams: [
      {
        code: inviteCode || ''
      }
    ],
    onFinally() {
      router.push(`/lottery${location?.hash || ''}`);
    }
  });

  return null;
}
